import Vue from 'vue'
import { inject } from 'vue'
import Vuex from 'vuex'
import api from './api'

Vue.use(Vuex)

type User = {
  mobile: string
}

const store = new Vuex.Store<{
  user: User | null
  isLogin: boolean
}>({
  state: {
    user: null,
    isLogin: !!localStorage.getItem('token'),
  },
  getters: {
    mallOnly(state) {
      return (
        state.user &&
        ['18981180287', '15000897081', '13801929498'].includes(
          state.user.mobile
        )
      )
    },
    memberOnly(state) {
      return state.user && state.user.mobile == '15821911041'
    },
    isSuperAdmin(state) {
      return (
        state.user && ['13764040429', '18521530284'].includes(state.user.mobile)
      )
    },
    hideDashboard(state) {
      if (!state.user) {
        return true
      }
      const hideByMobile = ['15900920597', '18930511489'].includes(
        state.user.mobile
      )
      return store.getters.mallOnly || store.getters.memberOnly || hideByMobile
    },
  },
  actions: {
    async login({ commit }, form) {
      return api.login(form).then(response => {
        localStorage.setItem('token', response.data.token)
        commit('login')
      })
    },
  },
  mutations: {
    login(state) {
      state.isLogin = true
    },
  },
})
export default store

export const useStore = () => inject<typeof store>('store')!
